
import { LoginLayoutBody } from 'components/Login';
import { FORMDATA } from 'constants/Data';
import { LoginLayout } from 'layouts/Login';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchProfileAction } from '../../redux/actions/profileAction';
import { loginAction } from '../../redux/slices/loginSlice';


const Login = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const [isPasswordValidate, setIsPasswordValidate] = useState(false);


	const onSubmit = async (values: any) => {
		if (isPasswordValidate) {
			setIsLoading(true);
				dispatch(loginAction({ ...values }) as any)
					.unwrap()
					.then((res: any) => {
						dispatch(fetchProfileAction() as any)
							.unwrap()
							.then((res: any) => {
								setIsLoading(false);
								// if (res.data.isSuperAdmin) {
								// 	navigate('/admin');
								// } else {
									navigate('/');
								// }
							});
					})
					.catch(() => {
						setIsLoading(false);
						navigate('/login');
					});
			}
	}

	// JSX for the Login page
	return (
		<LoginLayout>
			<LoginLayoutBody
				title="Log in"
				formData={FORMDATA.loginFields}
				buttonTitle={'Sign in'}
				redirectUrl="/forgot-password"
				redirectText="Forgot password?"
				onSubmit={onSubmit}
				isLoading={isLoading}
				setIsPasswordValidate={setIsPasswordValidate}
			></LoginLayoutBody>
			{/* <></> */}
		</LoginLayout>
	);
};

export default Login;
